import * as React from 'react'
import Image, { StaticImageData } from 'next/image'
import * as changeCase from 'capital-case'
import { Container } from '../Container'
import { Button } from '../Button'
import { StarsAndRatings } from '../SEMPage/StarsAndRatings'
import googleLogoIcon from '../../../public/img/icons/google-logo-icon.png'
import expect1 from '../../../public/img/expect-1.png'
import expect2 from '../../../public/img/expect-2.png'
import expect3 from '../../../public/img/expect-3.png'

import uri from '../../../public/img/nubrakes-van-house-800-num.jpg'
import classNames from 'classnames'
export const SuccessPageHeader: React.FC<{
  year: string
  firstName: string
  title: string
  othersSaying: string
  make: string
  image: any
  model: string
}> = () => {
  return (
    <section className="py-0">
      <div className="flex flex-col justify-center align-center h-1/4" style={{ position: 'relative', width: '100%' }}>
        <Image
          src={uri}
          priority={true}
          alt="NuBrakes Header Van Image"
          placeholder="blur"
          layout={'fill'}
          objectFit="cover"
          objectPosition="bottom center"
        />
        <div
          id="overlay"
          style={{
            minHeight: '100%',
            width: '100%',
            position: 'absolute',
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,.75)',
          }}
        />
        <div style={{ zIndex: 2 }}>
          <Container className="pb-4 text-center">
            <SocialProofBadge />
          </Container>
        </div>
      </div>
      <div className="flex flex-col">
        <WhatToExpectSection />
      </div>
    </section>
  )
}

export const WhatToExpectSection = () => {
  return (
    <>
      <div className="block">
        <div className="flex flex-col items-center gap-1 lg:gap-4 p-3 lg:pt-6 pt-3 lg:p-8 lg:pb-8 bg-gray-50">
          <div className="max-w-xs lg:max-w-4xl">
            <h3 className={'text-center text-xl lg:text-4xl m-0'}>what you can expect</h3>
          </div>
          <div className="flex flex-col lg:flex-row gap-3">
            <ExpectNextItem
              image={expect1}
              title={`we come to you`}
              description={`Convenient service where you’re parked. Open 7 days, same-day service available.`}
            />
            <ExpectNextItem
              image={expect2}
              title={`Focus on quality`}
              description={<>Expert techs, high-quality parts. <br/> Backed by our Warranty Guarantee.</>}
            />
            <ExpectNextItem
              image={expect3}
              title={`Transparent process`}
              description={`We recommend only what’s needed with upfront pricing and no hidden fees`}
            />
          </div>
        </div>
      </div>
    </>
  )
}
export const PictureSection: React.FC<{
  othersSaying: string
  image: any
  year: string
  make?: string
  model?: string
}> = ({ year, othersSaying, image, make = 'Chevrolet', model = '' }) => {
  return (
    <div className="p-8 pt-6 bg-white w-full h-full">
      <div
        className="mx-auto p-3 border-gray-800 bg-white"
        style={{ width: '100%', height: 200, position: 'relative' }}
      >
        <Image className={'mx-auto '} src={image} layout="fill" objectFit="scale-down" alt={`${make} Logo Image`} />
      </div>
      <p className="pt-3 pb-0 text-center" style={{ fontSize: 24, fontWeight: 'bold', lineHeight: 1 }}>
        {othersSaying}
      </p>
      <div className="text-center lg:hidden">
        <StarsAndRatings />
      </div>
      <div style={{ color: '#a6adb4' }}>
        <p className={'m-0'}>
          “Amazing service! The whole process from setting the appointment to the repairs could not have been smoother
          or more convenient.”
        </p>
        <p>
          <b>{`— Lisa S., ${year} ${changeCase.capitalCase(make)} ${changeCase.capitalCase(model)}`}</b>
        </p>
      </div>
      <div className="hidden lg:block">
        <SocialProofBadge />
      </div>
    </div>
  )
}

export const SocialProofBadge: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center p-1 lg:p-[14px] rounded-md">
      <div className="flex gap-5 items-center mb-2">
        <StarsAndRatings withPoints />
        <div className="flex items-center gap-2">
          <Image
            src={googleLogoIcon}
            height={20}
            width={20}
            objectPosition="bottom center"
            priority={true}
            alt="Valvoline logo"
          />
          <span className="text-white">(14,270 Reviews)</span>
        </div>
      </div>
      <h2 className="text-white text-2xl lg:text-5xl max-w-xs lg:max-w-xl uppercase m-0">
        a 5-star experience, coming right up!
      </h2>
      <Button style={{ fontFamily: 'IndustryInc-Base' }} className="text-base sm:w-auto py-2 mx-auto mt-3 px-6 font-normal">
        Need Help? (512) 640 2560
      </Button>
    </div>
  )
}

type ExpectNextItemProps = {
  number?: number
  image?: StaticImageData
  title: string
  description: string | React.ReactNode
  strongDescription?: boolean
}
export const ExpectNextItem: React.FC<ExpectNextItemProps> = ({ title, description, image, strongDescription }) => {
  return (
    <div className="flex flex-col border rounded-md overflow-hidden w-72 bg-white">
      <div className="h-20 lg:h-52 w-full relative">
        <Image src={image} objectFit="cover" layout="fill" alt="" />
      </div>
      <div className="flex flex-col items-center py-2 px-4 text-center">
        <h4 className="m-0 leading-0 text-[1.2rem] lg:text-xl leading-tight uppercase">
          {title}
        </h4>
        <p
          className={classNames('text-[0.93rem] lg:text-base m-0', strongDescription ? 'text-[#F00C] font-semibold' : 'text-[#000C]')}
        >
          {description}
        </p>
      </div>
    </div>
  )
}
